export const APPLICATION_CONFIGURATIONS = {
  // Paths used in routing
  path: {
    login: "/",
    createLoanApplication: "/createloanapplication",
    updateLoanApplication: "/updateloanapplication",
    analystApproval: "/analystapproval",
    viewLoanApplication: "/viewloanapplication",
    forgotPassword: "/forgotpassword",
    changePassword: "/changepassword",
    dashboard: "/dashboard",
    dashboardAppresta: "/dashboard/appresta",
    userList: "/userlist",
    branchList: "/branchList",
    branchDetails: "/branchDetails",
    noDataFound: "/nodatafound",
    userDetails: "/userdetails",
    profileDetails: "/profiledetails",
    cashierCommissionBar: "/cashiercommissionbar",
    repayment: "/repayment",
    configurationDashboard: "/configuration",
    versionList: "/versionlist",
    AlgorithmDetails: "/AlgorithmDetails",
    emiConfigurationsList: "/emiConfigurationsList",
    emiConfigurationDetails: "/emiConfigurationDetails",
    configureEmiOnIndex: "/configureEmiOnIndex",
    cashiersLogout: "/logout",
    ServiceChat: "/serviceChat",
    chatDetails: "/chatDetails",
    acceptAgreement: "/acceptAgreement",
    loanDetails: "/loanDetails",
    loanPortfolio: "/loanPortfolio",
    auditTrail: "/auditTrail",
  },

  // Application language
  applicationLanguage: "es", //values should be en or es

  // File configurations for upload documents
  fileConfigurations: {
    size: 52428800,
    allowedExtensions: ["jpg", "jpeg", "pdf"],
    allowedImageExtensions: ["jpg", "jpeg", "png"],
    contractFileExtension: ["pdf"],
  },
};
